import { addDays, format } from 'date-fns'

export const CURRENCY_SIGNS = {
  CLF: 'UF',
  CLP: '$',
  EUR: '€',
  USD: 'US$',
  UTM: 'UTM'
}

export const CURRENCY_SIGNS_DICTIONARY = {
  CLF: 'CLF',
  CLP: 'CLP',
  EUR: 'EUR',
  USD: 'USD',
  UTM: 'UTM'
}

export const CURRENCY_DECIMALS_DICTIONARY = {
  CLF: 4,
  CLP: 0,
  EUR: 2,
  USD: 2,
  UTM: 4
}

export const QUOTE_SEARCH_ORDERS = [
  { name: 'Publicadas más recientes', value: '2' },
  { name: 'Próximas a cerrar', value: '4' }
]

export const QUOTE_SEARCH_ORDERS_DICTIONARY = {
  MOST_RECENT_PUBLISHED: 2,
  SOON_TO_CLOSE: 4
}

export const QUOTE_SEARCH_RECORDS_PER_PAGE = 15

export const QUOTE_STATUSES = [
  { name: 'Todos', value: 'all' },
  { name: 'Guardada', value: 1 },
  { name: 'Publicada', value: 2 },
  { name: 'Cerrada', value: 3 },
  { name: 'Proveedor seleccionado', value: 4 },
  { name: 'Cancelada', value: 5 },
  { name: 'Desierta', value: 6 }
]

export const QUOTE_STATUSES_DICTIONARY = {
  SAVED: 1,
  PUBLISHED: 2,
  CLOSED: 3,
  'Proveedor seleccionado': 4,
  CANCELLED: 5,
  DESERTED: 6,
  EVERYBODY: 'all'
}

export const QUOTE_STATUSES_TRANSLATION_DICTIONARY = {
  Guardada: 'SAVED',
  Publicada: 'PUBLISHED',
  Cerrada: 'CLOSED',
  'OC Omitida': 'SKIPPED_PURCHASE_ORDER',
  Cancelada: 'CANCELLED'
}

export const QUOTE_STATUSES_DICTIONARY_OPTIONS = {
  SAVED: 'SAVED',
  PUBLISHED: 'PUBLISHED',
  CLOSED: 'CLOSED',
  SKIPPED_PURCHASE_ORDER: 'SKIPPED_PURCHASE_ORDER',
  CANCELLED: 'CANCELLED'
}

export const QUOTE_STATUSES_PROVIDER = {
  DISABLED: 'INHÁBIL',
  UNACREDITED: 'SIN INFORMACIÓN',
  IN_PROGRESS: 'PENDIENTE',
  ENABLED: 'HÁBIL'
}

export const QUOTE_STATUSES_COLOR_DICTIONARY = {
  Cancelada: 'error',
  Cerrada: 'default',
  Desierta: 'orange',
  Guardada: 'orange',
  Publicada: 'success',
  'Proveedor seleccionado': 'primary',
  'OC Omitida': 'default'
}
export const QUOTE_STATUS_CANCELLED_AUTOMATICALLY = {
  CANCELLED_AUTOMATICALLY: 'Cancelacion Automatica',
  CANCELLED_AUT: 1,
  CANCELLED: 0
}

export const QUOTE_SEARCH_FILTER_INITIAL_PAGE = 1

export const QUOTE_SEARCH_FILTER_DEFAULT_ROWS = 20

export const QUOTE_SEARCH_FILTER_INITIAL_DIFF_DAYS = 1

export const QUOTE_SEARCH_FILTER_MAX_DIFF_DAYS = 90

export const QUOTE_SEARCH_FILTER_INITIAL_VALUES = {
  dateFrom: format(addDays(new Date(), -QUOTE_SEARCH_FILTER_INITIAL_DIFF_DAYS), 'dd/MM/yyyy'),
  dateTo: format(new Date(), 'dd/MM/yyyy'),
  id: '',
  keyword: '',
  orderBy: QUOTE_SEARCH_ORDERS_DICTIONARY.MOST_RECENT_PUBLISHED,
  organization: '',
  page: '1',
  region: '',
  status: QUOTE_STATUSES_DICTIONARY.PUBLISHED
}

export const USER_TYPES_DICTIONARY = {
  BUYER: 'BUYER',
  SELLER: 'SELLER'
}

export const USER_TYPES_TRANSLATION_DICTIONARY = {
  Comprador: 'BUYER',
  Proveedor: 'SELLER'
}

export const TYPE_OFFER_DICTIONARY = {
  TOTAL: 'TOTAL',
  PARCIAL: 'PARCIAL'
}

export const PURCHASE_ORDER_STATUS_DICTIONARY = {
  SAVED: 1,
  SEND_BY_ALLOW: 2,
  ALLOW: 3,
  SENT_SELLER: 4,
  ACCEPTED: 6,
  CANCELLED_REQUEST: 7,
  CANCELLED_BUYER: 8,
  CANCELLED: 9,
  REMOVED: 10,
  NOT_ACCEPTED: 11
}

export const SELECTION_CRITERIA_DICTIONARY = {
  LOWEST_OFFER: '1',
  OTHER: '3',
  TOTAL_LOWEST_OFFER: '4',
  TECHNICAL: '5'
}

export const QUOTE_BID_STATUS_DICTIONARY = {
  SAVED: 1,
  SEND: 2,
  INADMISSIBILITY: 3
}

export const ERRORS_DICTIONARY = {
  compraagil_message_error_nombre: {
    title: 'Nombre',
    message: 'El nombre es requerido'
  },
  compraagil_message_size_nombre: {
    title: 'Nombre',
    message: 'El rango de nombre es entre 1 y 200  caracteres'
  },
  compraagil_message_error_descripcion: {
    title: 'Descripción',
    message: 'La descripción es requerido'
  },
  compraagil_message_size_descripcion: {
    title: 'Descripción',
    message: 'El rango de descripción es entre 1 y 500  caracteres'
  },
  compraagil_message_error_fechaCierre: {
    title: 'Fecha cierre',
    message: 'Fecha vacía'
  },
  compraagil_message_size_fechaCierre: {
    title: 'Fecha cierre',
    message: 'Fecha no cumple con el formato'
  },
  compraagil_message_error_codigoComuna: {
    title: 'Comuna',
    message: 'Seleccionar una comuna'
  },
  compraagil_message_size_codigoComuna: {
    title: 'Comuna',
    message: 'Comuna no cumple con el formato'
  },
  compraagil_message_error_moneda: {
    title: 'Tipo moneda',
    message: 'La moneda es requerida'
  },
  compraagil_message_size_moneda: {
    title: 'Tipo moneda',
    message: 'El rango de moneda es entre 1 y 5  caracteres'
  },
  compraagil_message_error_codigoRegion: {
    title: 'Región',
    message: 'Seleccionar una región'
  },
  compraagil_message_size_codigoRegion: {
    title: 'Región',
    message: 'Región no cumple con el formato'
  },
  compraagil_message_error_direccion: {
    title: 'Dirección',
    message: 'La dirección es requerido'
  },
  compraagil_message_size_direccion: {
    title: 'Dirección',
    message: 'El rango de dirección es entre 1 y 500  caracteres'
  },
  compraagil_message_error_plazoEntrega: {
    title: 'Días hábiles',
    message: 'Seleccionar un valor mayor a 0'
  },
  compraagil_message_size_plazoEntrega: {
    title: 'Días hábiles',
    message: 'Plazo entrega no cumple con el formato'
  },
  compraagil_message_error_telefono: {
    title: 'Teléfono de contacto',
    message: 'El teléfono de contacto es requerido'
  },
  compraagil_message_size_telefono: {
    title: 'Teléfono de contacto',
    message: 'El rango de teléfono es entre 1 y 50  caracteres'
  },
  compraagil_message_error_nombreContacto: {
    title: 'Nombre y apellido',
    message: 'El nombre de contacto es requerido'
  },
  compraagil_message_size_nombreContacto: {
    title: 'Nombre y apellido',
    message: 'El rango de nombre de contacto es entre 1 y 200  caracteres'
  },
  compraagil_message_error_email: {
    title: 'Correo electrónico',
    message: 'Email inválido'
  },
  compraagil_message_size_email: {
    title: 'Correo electrónico',
    message: 'El rango de email es entre 1 y 200 de caracteres'
  },
  compraagil_message_error_monto: {
    title: 'Monto',
    message: 'El monto es requerido'
  },
  compraagil_message_size_monto: {
    title: 'Monto',
    message: 'El rango de monto es entre 1 y 12 de caracteres'
  },
  compraagil_message_error_codigo_solicitud: {
    title: 'Código de solicitud',
    message: 'Código de solicitud es requerido'
  },
  compraagil_message_size_codigo_solicitud: {
    title: 'Código de solicitud',
    message: 'El rango de código de Solicitud es entre 1 y 255  caracteres'
  },
  compraagil_message_size_cotizacion_descripcion: {
    title: 'Detalle cotización',
    message: 'Rango de descripción es entre 1 y 255 caracteres'
  },
  compraagil_message_error_solicitud_producto_idcategoria: {
    title: 'Id. categoría',
    message: 'Producto sin categoría'
  },
  compraagil_message_error_solicitud_producto_cantidad: {
    title: 'Cantidad',
    message: 'Producto sin cantidad'
  },
  compraagil_message_error_solicitud_producto_codigoProducto: {
    title: 'Código del producto',
    message: 'Producto sin código de producto'
  },
  compraagil_message_error_cotizacion_codigoCotizacion: {
    title: 'Código cotización',
    message: 'Código cotización es inválido'
  },
  compraagil_message_size_cotizacion_codigoCotizacion: {
    title: 'Código cotización',
    message: 'Código cótización es entre 1 y 255 caracteres'
  },
  compraagil_message_error_cotizacion_moneda: {
    title: 'Código cotización',
    message: 'Moneda cotización inválido'
  },
  compraagil_message_size_cotizacion_moneda: {
    title: 'Moneda',
    message: 'Moneda es entre 1 y 20 caracteres'
  },
  compraagil_message_error_cotizacion_descripcion: {
    title: 'Descripción',
    message: 'Descripción es inválido'
  },
  compraagil_message_error_cotizacion_montoTotal: {
    title: 'Monto total',
    message:
      'El monto total cotizado no debe superar las ReplaceMaxUtm UTM. Equivalente en pesos a $maximumAmountFormater'
  },
  compraagil_message_error_cotizacion_montoNeto: {
    title: 'Monto neto',
    message: 'Valor monto neto inválido'
  },
  compraagil_message_error_cotizacion_totalImpuesto: {
    title: 'Total impuesto',
    message: 'Valor total impuesto inválido'
  },
  compraagil_message_error_cotizacion_codigoImpuesto: {
    title: 'Código impuesto',
    message: 'Tipo impuesto inválido'
  },
  compraagil_message_error_cotizacion_montoDespacho: {
    title: 'Monto despacho',
    message: 'Valor monto despacho inválido'
  },
  compraagil_message_error_cotizacion_sinProductos: {
    title: 'Productos',
    message: 'Lista de productos vacía'
  },
  compraagil_message_error_cotizacion_solicitudNoEncontrada: {
    title: 'Solicitud',
    message: 'Compra Ágil no encontrada'
  },
  compraagil_message_error_cotizacion_solicitudExpirada: {
    title: 'Solicitud',
    message: 'Solicitud de cotización no encontrada'
  },
  compraagil_message_error_cotizacion_producto_solicitudCotizacionProductoId: {
    title: 'Productos',
    message: 'Referencia a producto de solicitud inválida'
  },
  compraagil_message_error_cotizacion_producto_codigoProducto: {
    title: 'Código productos',
    message: 'Producto sin código de producto'
  },
  compraagil_message_error_cotizacion_producto_cantidad: {
    title: 'Cantidad',
    message: 'Producto con cantidad inválida'
  },
  compraagil_message_error_cotizacion_producto_precioUnitario: {
    title: 'Precio unitario',
    message: 'Producto con precio unitario inválido'
  },
  compraagil_message_error_cotizacion_producto_montoTotal: {
    title: 'Monto total',
    message: 'Producto con monto total inválido'
  },
  compraagil_message_error_cotizacion_listaProductosIncompleta: {
    title: 'Productos',
    message: 'Lista de productos incompleta'
  },
  compraagil_message_error_cotizacion_producto_inclusion: {
    title: 'Inclusión',
    message: 'Producto sin información de inclusión'
  },
  compraagil_message_error_cotizacion_fechaCierre: {
    title: 'Fecha cierre',
    message: 'Fecha cierre inválida'
  },
  compraagil_message_error_cotizacion_cierre_detalle: {
    title: 'Cierre detalle',
    message: 'El rango de detalle es entre 0 y 500 caracteres'
  },
  compraagil_oc_message_error_nombre: {
    title: 'Nombre',
    message: 'El nombre es requerido'
  },
  compraagil_oc_message_error_size_nombre: {
    title: 'Nombre',
    message: 'El rango de nombre para la orden-compra es entre 1 y 255'
  },
  compraagil_oc_message_error_despacho: {
    title: 'Despacho',
    message: 'La dirección de despacho es requerido'
  },
  compraagil_oc_message_error_size_despacho: {
    title: 'Despacho',
    message: 'El rango de dirección de despacho es entre 1 y 200  caracteres'
  },
  compraagil_oc_message_error_responsable_pago: {
    title: 'Responsable del pago',
    message: 'El responsable de pago es requerido'
  },
  compraagil_oc_message_error_responsable_recepcion: {
    title: 'Responsable de recepción',
    message: 'El responsable de recepción es requerido'
  },
  compraagil_oc_message_error_plazo: {
    title: 'Plazo de entrega',
    message: 'El plazo de entrega es requerido'
  },
  compraagil_oc_message_error_plancompra: {
    title: 'Plan de compra',
    message: 'El plan de compra es requerido'
  },
  compraagil_oc_message_error_autorizacion: {
    title: 'Plan de compra',
    message: 'El plan de compra es requerido'
  },
  compraagil_oc_message_error_solicitud: {
    title: 'Id. solicitud',
    message: 'El id-solicitud es requerido'
  },
  compraagil_oc_message_error_cotizacion: {
    title: 'Id. cotización',
    message: 'El id-cotización es requerido'
  },
  compraagil_oc_message_error_razonsocial: {
    title: 'Razón social',
    message: 'La razón social es requerida'
  },
  compraagil_oc_message_error_criterio: {
    title: 'Criterio de selección',
    message: 'El criterio de selección es requerido'
  },
  compraagil_oc_message_error_usuario: {
    title: 'Usuario',
    message: 'El usuario es requerido'
  },
  compraagil_message_error_generic_jwt_data: {
    title: 'Token',
    message: 'Token con datos inválidos'
  },
  compraagil_error_rol_invalido: {
    title: 'Rol usuario',
    message: 'Rol usuario no permite esta acción'
  },
  compraagil_error_oc_0001: {
    title: 'Compra ágil',
    message: 'Compra ágil no encontrada'
  },
  compraagil_error_oc_0002: {
    title: 'Compra ágil',
    message: 'Compra ágil no se encuentra cerrada'
  },
  compraagil_error_oc_0003: {
    title: 'Compra ágil',
    message: 'Compra ágil sin Cotizaciones'
  },
  compraagil_error_oc_0004: {
    title: 'Selección de oferta',
    message: 'Debe seleccionar al menos una oferta'
  },
  compraagil_error_oc_0005: {
    title: 'Selección de oferta',
    message: 'Debe seleccionar ofertas que pertenezcan a la Compra ágil'
  },
  compraagil_error_oc_0006: {
    title: 'Selección de oferta',
    message: 'Oferta no puede ser reseleccionada'
  },
  compraagil_error_oc_0007: {
    title: 'Selección de oferta',
    message: 'Selección simultánea de Ofertas Totales y Parciales no soportada'
  },
  compraagil_error_oc_0008: {
    title: 'Selección de oferta',
    message: 'Múltiples Ofertas Totales no soportado'
  },
  compraagil_error_oc_0009: {
    title: 'Selección de oferta',
    message: 'Monto Cotizaciones seleccionadas sobrepasa máximo UTMs'
  },
  compraagil_error_oc_0010: {
    title: 'Criterio de selección',
    message: 'Criterio de Selección es obligatorio'
  },
  compraagil_error_oc_0011: {
    title: 'Código de criterio',
    message: 'Código criterio no encontrado'
  },
  compraagil_error_oc_0012: {
    title: 'Criterio de selección',
    message: 'Debe ingresar un texto para criterio selección "Otro"'
  },
  compraagil_error_oc_0013: {
    title: 'Criterio de selección',
    message: 'Mínimo Criterio selección "Otro" son 5 caracteres'
  },
  compraagil_error_oc_0014: {
    title: 'Criterio de selección',
    message: 'No se encontró el monto mínimo entre las cotizaciones'
  },
  compraagil_error_oc_0015: {
    title: 'Criterio de selección',
    message: 'No se encontró la cotización seleccionada para la OC.'
  },
  compraagil_error_oc_0016: {
    title: 'Criterio de selección',
    message: 'Seleccionó el criterio "precio más bajo", pero no corresponde a la oferta más económica.'
  },
  compraagil_error_oc_0017: {
    title: 'Criterio de selección',
    message: 'La orden corresponde a la oferta más barata, pero el criterio de selección no es "precio más bajo".'
  },
  compraagil_error_cotizacion_001: {
    title: 'Solicitud de cotización',
    message: 'Solicitud de Cotización está inactiva'
  },
  compraagil_error_cotizacion_002: {
    title: 'Productos',
    message: 'Lista de productos incompleta'
  },
  compraagil_error_cotizacion_003: {
    title: 'Productos',
    message: 'Cotización debe incluir al menos un Producto'
  },
  compraagil_error_cotizacion_004: {
    title: 'Productos',
    message: 'Cotización debe incluir al menos un Producto'
  },
  compraagil_error_cotizacion_005: {
    title: 'Código de impuesto',
    message: 'Código impuesto no encontrado'
  },
  compraagil_error_cotizacion_006: {
    title: 'Productos',
    message: 'Listado de productos incompleto'
  },
  compraagil_error_cotizacion_007: {
    title: 'Código de producto',
    message: 'Código producto no corresponde al de la solicitud'
  },
  compraagil_error_cotizacion_008: {
    title: 'Solicitud de cotización',
    message: 'Ya has postulado a esta Solicitud de Cotización'
  },
  compraagil_error_cotizacion_009: {
    title: 'Adjuntar archivos',
    message: 'Estado de Compra ágil no permite adjuntar documentos'
  },
  compraagil_error_cotizacion_010: {
    title: 'Adjuntar archivos',
    message: 'No se puede eliminar archivo'
  },
  compraagil_error_cotizacion_011: {
    title: 'Adjuntar archivos',
    message: 'Solicitud se encuentra cerrada'
  },
  compraagil_error_solicitud_001: {
    title: 'Moneda',
    message: 'Moneda no encontrada'
  },
  compraagil_error_solicitud_002: {
    title: 'Cotización',
    message: 'La cotización supera las ReplaceMaxUtm UTM permitidas'
  },
  compraagil_error_solicitud_003: {
    title: 'Organismo',
    message: 'Organismo no existe'
  },
  compraagil_error_solicitud_004: {
    title: 'No fue posible ampliar la fecha de cierre:',
    message: 'La nueva fecha de cierre debe ser posterior a la ingresada anteriormente.'
  },
  compraagil_error_solicitud_005: {
    title: 'Solicitud de cotización',
    message: 'Solicitud Cotización no puede cerrarse'
  },
  compraagil_error_solicitud_006: {
    title: 'Compra ágil',
    message: 'Compra ágil no pertenece a usuario'
  },
  compraagil_error_solicitud_007: {
    title: 'Solicitud',
    message: 'Solicitud ya se encuentra en estado cerrada'
  },
  compraagil_error_solicitud_008: {
    title: 'Solicitud',
    message: 'Solicitud no se encuentra en estado Proveedor seleccionado'
  },
  compraagil_error_solicitud_009: {
    title: 'Compra ágil',
    message: 'Compra ágil no tiene acciones OC pendientes'
  },
  compraagil_error_solicitud_010: {
    title: 'Selección de ofertas',
    message: 'No cuenta con ofertas suficientes para reselección'
  },
  compraagil_error_solicitud_011: {
    title: 'Compra ágil',
    message: 'Compra ágil no se encuentra en estado Proveedor seleccionado'
  },
  compraagil_error_solicitud_012: {
    title: 'Compra ágil',
    message: 'Compra ágil no puede tener OCs activas para completar esta operación'
  },
  compraagil_error_solicitud_013: {
    title: 'Compra ágil',
    message: 'Fecha cierre no cumple plazo mínimo para publicar'
  },
  compraagil_error_solicitud_014: {
    title: 'Compra ágil',
    message: 'Archivo no encontrado'
  },
  compraagil_error_solicitud_015: {
    title: 'Compra ágil',
    message: 'La solicitud no cumple con lo solicitado'
  },
  compraagil_error_solicitud_016: {
    title: 'Compra ágil',
    message: 'Solicitud ya se encuentra publicada'
  },
  compraagil_error_solicitud_017: {
    title: 'Compra ágil',
    message: 'El campo multa-sanción no puede ser nulo'
  },
  compraagil_error_solicitud_018: {
    title: 'Compra ágil',
    message: 'No se pudo publicar la Compra ágil. Favor intentar más tarde'
  },
  compraagil_error_solicitud_tipo_presupuesto_019: {
    title: 'Compra ágil',
    message: 'No se ha seleccionado el tipo de presupuesto'
  },
  compraagil_error_inhabilidad_001: {
    title: 'No puedes enviar cotizaciones en Compra Ágil.',
    message:
      'Para poder participar de Compra Ágil y enviar tu cotización, tu empresa debe estar en estado HÁBIL en Mercado Público.'
  },
  proveedor_no_habilitado_001: {
    title: 'Dado el tamaño de tu empresa, no puedes participar en este proceso.',
    message:
      'Recuerda que Compra Ágil es un procedimiento para Empresas de Menor Tamaño (EMT). Dado el tamaño de tu empresa, sólo podrás cotizar en los procesos cuyas convocatorias fueron ampliadas para la participación de las empresas independiente de su tamaño.'
  },
  proveedor_priorizado_001: {
    title:
      'Dado que eres una Empresa de Menor Tamaño (EMT), para participar completa la siguiente información y envía tu cotización..',
    message: ' '
  },
  participar_cotizaciones: {
    title: 'Estas son las oportunidades en Compra Ágil en las que puedes participar.',
    message:
      'Recuerda que Compra Ágil es un procedimiento para Empresas de Menor Tamaño (EMT). Dado el tamaño de tu empresa, solo podrás participar del segundo llamado que se realice para ampliar la convocatoria.'
  },
  UNAUTHORIZED_ERROR: {
    title:
      'Se ha detectado un comportamiento inusual en tu ingreso. Te pedimos que vuelvas a intentar dentro de unos minutos, o bien, contacta con nuestra Mesa de Ayuda.',
    message: ' '
  },
  UNKNOWN_ERROR: {
    title:
      'En estos momentos tenemos problemas para realizar el envio de información. Por favor, consulta en unos minutos más.',
    message: ' '
  },
  DEFAULT_ERROR: {
    title: '',
    message:
      'En estos momentos tenemos problemas para realizar la descarga de información. Por favor, consulta en unos minutos más.'
  }
}

export const DOCUMENT_MIME_TYPES = `application/pdf, image/jpeg, application/vnd.openxmlformats-officedocument.wordprocessingml.document, 
  application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, image/png,application/msword, text/plain,
  application/vnd.ms-excel, application/x-rar-compressed, application/zip, image/webp, video/mp4, 
  application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.oasis.opendocument.text,
  application/vnd.ms-powerpoint, application/rtf, text/html, image/vnd.dwg, image/bmp, application/vnd.ms-xpsdocument, Image/heic, 
  image/heif, application/vnd.oasis.opendocument.spreadsheet, image/tiff, application/vnd.ms-excel.sheet.macroenabled.12, 
  application/vnd.ms-outlook, image/gif, text/html, application/x-7z-compressed, application/vnd.ms-excel.sheet.binary.macroenabled.12,
  application/vnd.ms-excel.template.macroenabled.12, text/csv, application/octet-stream, application/oxps, application/x-7z-compressed,
  Application/x-ms-shortcut
`

export const PURCHASE_ORDER_SEARCHER_URL = '/PurchaseOrder/Modules/PO/SearchPurchaseOrder.aspx'
export const PURCHASE_ORDER_SEARCHER_SELLER_URL = '/PurchaseOrder/Modules/PO/SearchPurchaseOrderProveedor.aspx'
export const PURCHASE_ORDER_URL = '/PurchaseOrder/Modules/PO/DetailsPurchaseOrder.aspx?CodigoOC='
export const PURCHASE_ORDER_ISSUE_URL = '/PurchaseOrder/WizardCreateAndRedirect.aspx?POMODE=POEdit&porId='

export const FINES_PENALTIES_FILE = 'multas-sanciones-procedimientos.pdf'

export const PROVIDER_IDENTIFIER_KEYS_DICTIONARY = {
  'business-name': 'businessName',
  dni: 'dni',
  id: 'id'
}

export const PROVIDER_IDENTIFIER_LABELS_DICTIONARY = {
  'business-name': 'nombre o razón social',
  dni: 'rut proveedor',
  id: 'id extranjero'
}

export const PROVIDER_IDENTIFIER_OPTIONS = [
  { name: 'RUT', value: 'dni' },
  { name: 'Razón social', value: 'business-name' },
  { name: 'ID extranjero', value: 'id' }
]

export const PROVIDER_PRIORIZED_IDENTIFIER_KEYS_DICTIONARY = {
  priorized: 'EMPRESA NO PRIORIZADA - PRIMER LLAMADO'
}

export const PROVIDER_ROWS = 20

export const EXPIRES_AT = 60 * 60

export const DECLARATION_INADMISSIBILITY_JUSTIFICATION_DICTIONARY = {
  OTHER: '5'
}

export const BINARY_BUDGET_TYPE = [
  {
    label: 'Monto estimado',
    value: 'Estimado',
    orden: 1
  },
  {
    label: 'Monto disponible',
    value: 'Disponible',
    orden: 2
  }
]
export const PROVIDER = {
  NOT_PRIORIZED: 'NO EMT',
  COMPANYSIZE: 'EMPRESA DE MENOR TAMAÑO'
}

export const CALL_AGILE_PURCHASE = {
  PRIMER_LLAMADO: 'Primer Llamado'
}

export const NOTIFICATION_TOOLTIPS =
  'Los proveedores priorizados corresponden a todos los proveedores clasificados como pequeña y mediana empresa.'

export const CALL_AGILE_QUOTE_STATUSES = {
  PUBLISHED: 2
}

export const PARTICIPANT_LIST_PREFIX = 'CA'

export const FOREIGN_PROVIDER_DICTIONARY = {
  NATIONAL: '0',
  FOREIGN: '1'
}

export const FILTERS_KEYS_DICTIONARY = {
  dateFrom: 'desde',
  dateTo: 'hasta',
  keyword: 'q',
  myAreas: 'misRubros',
  myBid: 'misOfertas',
  myQuotes: 'misCompras',
  organization: 'org',
  rows: 'size',
  status: 'estado'
}

export const SEARCHS_KEYS_DICTIONARY = {
  MY_BID: 'myBid',
  MY_AREAS: 'myAreas',
  PRIORIZED: 'priorized',
  QUOTE_CLOSED: '5dias',
  PURCHASE_STATUS: 'ocCanceladaEliminada'
}

export const CANCELLATION_TYPE_DICTIONARY = {
  MANUAL: 'MAN',
  AUTO: 'AUTO'
}

export const DISCLAIMER_CANCELLATION_DICTIONARY = {
  SHOW: '1',
  NONE: '0'
}

export const SUSTAINABLE_PURCHASES_FILE = 'instructivo-de-compras-publicas-sustentables.pdf'

export const YES_OR_NO_OPTIONS = [
  { id: 1, label: 'Si', value: 'yes' },
  { id: 2, label: 'No', value: 'no' }
]

export const SEARCH_URL_SIZE_LIMIT = 1

export const QUOTE_BID_SIZE_PAGINATION = 6

export const SELECT_OFFER_DIALOG_STATES_DICTIONARY = {
  INITIAL: 'INITIAL',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
}

export const PURCHASE_ORDER_VALID_DICTIONARY = {
  ACTIVE: 1,
  NO_ACTIVE: 2
}

export const REDIRECT_PURCHASE_SHEET = '/PurchaseOrder/Modules/PO/DetailsPurchaseOrder.aspx?codigooc='

export const SNACKBAR_CLOSE_TIMEOUT = 5000

export const SNACKBAR_POSITIONS = {
  right: 'right',
  top: 'top'
}
